module.exports = __webpack_public_path__ + "icon-dstore._nlgopjb.svg";